'use strict';

import React from 'react';

class Fieldset extends React.Component {
    render() {
        return (
            <div>
                <h5 className={"fieldset-legend " + this.props.className}>{this.props.legend}</h5>
                <fieldset>
                    <legend>{this.props.legend}</legend>
                    {this.props.children}
                </fieldset>
            </div>
        );
    }
}

export default Fieldset; 
